import { Subscription } from "./types";

export function getLicenseId(
  subscription: Pick<Subscription, "id" | "subscriptionId">,
): string {
  return subscription.id || subscription.subscriptionId;
}
